'use client';

import Link from 'next/link';
import { interpolateStringWithData } from 'utils';
import { c } from '../../../utils/tailwind-merge';
import { Badge } from '../../atoms/Badge';
import { StarsV2 } from '../../molecules/Stars.v2';
import { LatestUserReviewProps } from './LatestUserReview.types';

const REVIEW_HASH = '#reviews';

export const LatestUserReview = ({
  microcopy,
  stars,
  gifted,
  title,
  review,
  onClickReadMore,
  className = '',
}: LatestUserReviewProps) => {
  return (
    <article>
      <div className={c('w-full max-w-xl rounded-t text-content', className)}>
        <p className="tiny-text mb-6 font-medium text-black dark:text-content">
          {interpolateStringWithData(microcopy.title, {
            stars: stars.value,
          })}
        </p>
        <header className="flex w-full flex-wrap gap-3 md:items-center">
          <StarsV2
            className="items-start"
            width={20}
            height={20}
            ariaLabel={microcopy.stars.ariaLabel}
            variant="blue"
            {...stars}
          />
          {gifted && (
            <span className="text-sm">
              <Badge text={microcopy.gifted} />
            </span>
          )}
        </header>
        <h3 className="mt-3 text-sm font-bold">{title}</h3>
        <p className="my-4 line-clamp-4 text-sm">{review}</p>
        <Link
          className="inline-block text-sm text-link no-underline"
          href={REVIEW_HASH}
          aria-label={microcopy.readMore}
          onClick={onClickReadMore}
        >
          {microcopy.readMore}
        </Link>
      </div>
    </article>
  );
};
